import React from 'react';
import Icon from '@mdi/react';
import { Tooltip } from 'antd';
import {
  mdiCartVariant,
  mdiCartRemove,
  mdiCartPlus,
  mdiAccountPlus,
  mdiAccountCheck,
  mdiAccountArrowLeft,
  mdiCreditCardOutline,
  mdiCancel,
  mdiViewDashboard,
  mdiMonitorEye,
  mdiEye,
  mdiClipboardListOutline,
  mdiCheckCircleOutline,
  mdiEmailCheckOutline,
  mdiTruckDeliveryOutline,
  mdiClipboardTextOutline,
  mdiAccountOutline,
  mdiCursorDefaultClickOutline,
  mdiCheckDecagramOutline,
  mdiClipboardAccountOutline,
  mdiCircleMultiple,
} from '@mdi/js';

const eventTypeMap = {
  begin_checkout: {
    title: 'Checkout Started',
    icon: mdiClipboardListOutline,
  },
  cart_viewed: {
    title: 'Cart Viewed',
    icon: mdiCartVariant,
  },
  checkout_address_info_submitted: {
    title: 'Address Info Submitted',
    icon: mdiClipboardTextOutline,
  },
  checkout_completed: {
    title: 'Checkout Completed',
    icon: mdiCheckCircleOutline,
  },
  checkout_contact_info_submitted: {
    title: 'Contact Info Submitted',
    icon: mdiClipboardAccountOutline,
  },
  checkout_shipping_info_submitted: {
    title: 'Shipping Info Submitted',
    icon: mdiTruckDeliveryOutline,
  },
  checkout_started: {
    title: 'Checkout Started',
    icon: mdiClipboardListOutline,
  },
  click: {
    title: 'Click',
    icon: mdiCursorDefaultClickOutline,
  },
  collection_viewed: {
    title: 'Collection Viewed',
    icon: mdiViewDashboard,
  },
  email_confirmed: {
    title: 'Email Confirmed',
    icon: mdiEmailCheckOutline,
  },
  free_plan_selected: {
    title: 'Free Plan Selected',
    icon: mdiCheckDecagramOutline,
  },
  free_purchase: {
    title: 'Free Purchase',
    icon: mdiCartPlus,
  },
  lead: {
    title: 'Lead',
    icon: mdiAccountPlus,
  },
  login: {
    title: 'Login',
    icon: mdiAccountCheck,
  },
  logout: {
    title: 'Logout',
    icon: mdiAccountArrowLeft,
  },
  none: {
    title: 'None',
    icon: mdiCancel,
  },
  page_viewed: {
    title: 'Page Viewed',
    icon: mdiMonitorEye,
  },
  pageview: {
    title: 'Page View',
    icon: mdiEye,
  },
  payment_info_submitted: {
    title: 'Payment Info Submitted',
    icon: mdiCreditCardOutline,
  },
  product_added_to_cart: {
    title: 'Product Added to Cart',
    icon: mdiCartPlus,
  },
  product_removed_from_cart: {
    title: 'Product Removed from Cart',
    icon: mdiCartRemove,
  },
  product_viewed: {
    title: 'Product Viewed',
    icon: mdiCartVariant,
  },
  purchase: {
    title: 'Purchase',
    icon: mdiCircleMultiple,
  },
  register: {
    title: 'Register',
    icon: mdiAccountOutline,
  },
};

const EventTypeIcons = ({
  event,
  size = 1,
  color,
  ShowTitle = false,
  showEventName = false,
  showIcon = true,
}) => {
  const eventType = eventTypeMap[event] || { title: 'Unknown', icon: mdiEye };

  return (
    <Tooltip title={ShowTitle && eventType.title} className='flex items-center gap-2'>
      {showEventName && <span> {eventType.title}</span>}
      {showIcon && <Icon path={eventType.icon} size={size} color={color} />}
    </Tooltip>
  );
};

export default EventTypeIcons;
